export default __webpack_public_path__ + "static/media/batteraside1.c897fc46.png";